// The script-tag entry (`render@1.js`): registers <instruction-md> and upgrades
// [data-instruction-md] hosts as soon as the DOM is ready. No globals beyond
// `window.instructionMd` for programmatic use.
import { autoload, define, outline, project, render, resolveAnchor } from "./index";

define();
const run = () => autoload();
if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", run, { once: true });
else run();

// `project` is the whole model — diagnostics, the delivered text, the headings —
// for a page that edits a document and wants to say whether it is valid
// (instruction.md's own front page does). It is already inside the bundle, as are
// `outline` and `resolveAnchor` — the navigation the contents and back matter use.
declare global { interface Window { instructionMd?: { render: typeof render; autoload: typeof autoload; define: typeof define; project: typeof project; outline: typeof outline; resolveAnchor: typeof resolveAnchor } } }
window.instructionMd = { render, autoload, define, project, outline, resolveAnchor };
export { render, autoload, define, project, outline, resolveAnchor };
